(function () {
  var popup = document.querySelector('[data-skyy-email-popup]');
  if (!popup) return;

  var dismissedKey = 'skyyEmailPopupDismissedUntil';
  var submittedKey = 'skyyEmailPopupSubmittedUntil';
  var sessionShownKey = 'skyyEmailPopupShown';
  var sessionShownCookie = 'skyyEmailPopupShown=1';
  var day = 24 * 60 * 60 * 1000;
  var hasShown = false;
  var closeButtons = popup.querySelectorAll('[data-skyy-email-popup-close]');
  var successPanel = popup.querySelector('[data-skyy-email-popup-success]');
  var errorPanel = popup.querySelector('[data-skyy-email-popup-errors]');

  function getStoredTime(key) {
    try {
      var value = window.localStorage.getItem(key);
      var time = value ? parseInt(value, 10) : 0;
      return Number.isFinite(time) ? time : 0;
    } catch (error) {
      return 0;
    }
  }

  function isSuppressed() {
    var now = Date.now();
    return getStoredTime(dismissedKey) > now || getStoredTime(submittedKey) > now;
  }

  function storeUntil(key, days) {
    try {
      window.localStorage.setItem(key, String(Date.now() + days * day));
    } catch (error) {
      // Storage is optional; the session cookie still prevents repeat display.
    }
  }

  function hasShownThisSession() {
    try {
      if (window.sessionStorage.getItem(sessionShownKey) === 'true') return true;
    } catch (error) {
      // Fall through to the session cookie.
    }
    return document.cookie.split('; ').indexOf(sessionShownCookie) !== -1;
  }

  function markShownThisSession() {
    try {
      window.sessionStorage.setItem(sessionShownKey, 'true');
    } catch (error) {
      // Keep the session-only cookie fallback below.
    }
    document.cookie = sessionShownCookie + '; path=/; SameSite=Lax';
  }

  function hasCompetingUi() {
    return Boolean(document.querySelector('cart-drawer.active, cart-notification .active, product-modal[open], .modal__content[open], [data-sticky-atb].is-visible'));
  }

  function setVisible(visible) {
    if (visible) {
      popup.removeAttribute('hidden');
      popup.removeAttribute('inert');
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
    } else {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('inert', '');
      popup.setAttribute('hidden', '');
    }
  }

  function showPopup() {
    if (hasShown || hasShownThisSession() || isSuppressed() || hasCompetingUi()) return;
    hasShown = true;
    markShownThisSession();
    setVisible(true);
  }

  function hidePopup(days) {
    setVisible(false);
    storeUntil(successPanel ? submittedKey : dismissedKey, days);
  }

  if (successPanel) {
    try {
      window.localStorage.removeItem(dismissedKey);
    } catch (error) {
      // The success message can still render without storage.
    }
    storeUntil(submittedKey, 30);
    hasShown = true;
    markShownThisSession();
    setVisible(true);
    successPanel.focus({ preventScroll: true });
  } else if (errorPanel) {
    hasShown = true;
    markShownThisSession();
    setVisible(true);
    var emailInput = popup.querySelector('input[type="email"]');
    if (emailInput) emailInput.focus({ preventScroll: true });
  } else if (!isSuppressed() && !hasShownThisSession()) {
    // A quiet slide-in appears only after meaningful engagement, never as a takeover.
    window.setTimeout(showPopup, 60000);

    var onScroll = function () {
      var scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0 && scrollTop / scrollable >= 0.65) {
        window.removeEventListener('scroll', onScroll);
        showPopup();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      hidePopup(successPanel ? 30 : 7);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
      hidePopup(successPanel ? 30 : 7);
    }
  });
})();
